import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { InitialsIconModule } from '../initials-icon/initials-icon.module';
import { AccountSelectorComponent } from './account-selector.component';

@NgModule({
  imports: [CommonModule, AngularMaterialModule, InitialsIconModule],
  declarations: [AccountSelectorComponent],
  exports: [AccountSelectorComponent],
})
export class AccountSelectorModule {}
